import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Card from '../../shared/components/Card';
import CardHeader from '../../shared/components/card-header/CardHeader';
import CardBody from '../../shared/components/CardBody';
import Paginator from '../../shared/components/Paginator';
import { I18nUtils } from '../../../i18n/I18nUtils';
import HeaderSearchRefreshFilterOptions from '../../shared/components/HeaderSearchRefreshFilterOptions';
import Row from '../../shared/components/Row';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as documentRevisionsActions from '../actions/documentRevisionsActions';
import * as documentStateActions from '../actions/documentStatesActions';
import DocumentRevisionsTable from '../../shared/components/DocumentRevisionsTable';
import StateManager from '../../shared/utils/StateManager';

class DocumentRevisionsCard extends React.Component {

    STATE_MANAGER_KEY = 'DOCUMENT_REVISIONS_CARD_';

    constructor(props) {
        super(props);

        this.onRefresh = this.onRefresh.bind(this);
        this.onSearch = this.onSearch.bind(this);
        this.onPage = this.onPage.bind(this);

        this.state = StateManager.getState(this.STATE_MANAGER_KEY + this.props.documentId);
    }

    componentWillMount() {
        this.props.documentStateActions.getDocumentStates();
        this.getDocumentRevisions();

        if (this.state.page !== 1) {
            this.getLastDocumentRevisions();
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if ( prevState.page !== this.state.page ||
            prevState.search !== this.state.search ||
            prevState.filter !== this.state.filter ||
            prevProps.revisionCreatedId !== this.props.revisionCreatedId ) {
            this.getDocumentRevisions();
        }
        StateManager.saveState(this.STATE_MANAGER_KEY + this.props.documentId, this.state);
    }

    getDocumentRevisions() {
        this.props.documentRevisionsActions.getDocumentRevisions(
            this.props.documentId,
            this.state.page,
            this.state.search,
            this.state.filter,
        );
    }

    getLastDocumentRevisions() {
        this.props.documentRevisionsActions.getDocumentRevisions(
            this.props.documentId,
            1,
        );
    }

    onRefresh() {
        this.getDocumentRevisions();
    }

    onSearch(search) {
        this.setState({ search: search, page: 1 });
    }

    onPage(page) {
        this.setState({ page });
    }

    getFilterOptions() {
        const filterOptions = this.props.documentStates.map((documentState) => {
            return {
                id: documentState.id,
                title: documentState.name,
                active: documentState.id === this.state.filter,
                color: '#' + documentState.color,
                onClick: () => {
                    this.setState({ filter: documentState.id, page: 1 });
                },
            };
        });
        filterOptions.unshift({
            id: 0,
            title: I18nUtils.tr('TR_TODOS'),
            active: 0 === this.state.filter,
            onClick: () => {
                this.setState({ filter: 0, page: 1 });
            },
        });
        return filterOptions;
    }

    renderFilterName() {
        const states = _.keyBy(this.getFilterOptions(), 'id');
        if ( states && states[this.state.filter] ) {
            return states[this.state.filter].title;
        }
        return '';
    }

    renderHeaderOptions() {
        return (
            <HeaderSearchRefreshFilterOptions
                onRefresh={this.onRefresh}
                onSearch={this.onSearch}
                searchText={this.state.search}
                filterOptions={this.getFilterOptions()}
            />
        );
    }

    render() {
        const {
            rntInfo,
        } = this.props;

        return (
            <Row clearfix>
                <Card loading={this.props.loading}>
                    <CardHeader
                        title={this.props.title.toUpperCase()}
                        subtitle={this.renderFilterName()}
                        rightOptions={this.renderHeaderOptions()}
                    />
                    <CardBody className="table-responsive">
                        {rntInfo &&
                            <div
                                style={{
                                    marginBottom: '10px',
                                    marginTop: '10px',
                                    border: '1px solid',
                                    padding: '10px',
                                    overflow: 'scroll',
                                }}
                            >
                                {JSON.stringify(rntInfo)}
                            </div>
                        }
                        <DocumentRevisionsTable
                            data={this.props.revisions}
                            error={this.props.error}
                            hideOutsource={true}
                        />
                        <Paginator onPage={this.onPage} data={this.props.pagination}/>
                    </CardBody>
                </Card>
            </Row>
        );
    }
}

const mapStateToProps = (state, ownProps) => {

    let error = state.documentRevisions.error;
    if ( !error && state.documentRevisions.revisions.length === 0 && !state.documentRevisions.loading ) {
        error = I18nUtils.tr('TR_NO_EXISTEN_RESULTADOS');
    }
    return {
        revisions: state.documentRevisions.revisions,
        pagination: state.documentRevisions.pagination,
        loading: state.documentRevisions.loading || state.documentRevisions.lastRevisionLoading,
        error: error,
        documentStates: state.documentStates.documentStates,
        revisionCreatedId: state.documentRevisions.revisionCreatedId,
        rntInfo: state.documentRevisions.rntInfo,
    };
};

const mapDispatchToProps = dispatch => ( {
    documentRevisionsActions: bindActionCreators(documentRevisionsActions, dispatch),
    documentStateActions: bindActionCreators(documentStateActions, dispatch),
} );

export default connect(mapStateToProps, mapDispatchToProps)(DocumentRevisionsCard);

DocumentRevisionsCard.propTypes = {
    documentId: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
};

DocumentRevisionsCard.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/documents/components/DocumentRevisionsCard.js